import React from 'react'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Stack from '@mui/material/Stack'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import Typography from '@mui/material/Typography'
import RightToWorkDocuments from './RightToWorkDocuments'
import { FormSection, YesNoQuestion } from './FormKit'

const RightToWork = ({ formValues, setFormValues }) => {
  const rightToWork = formValues?.rightToWork ?? {}
  const {
    citizenship,
    hasUKPassport,
    hasBirthCertificate,
    certificateRegistration,
  } = rightToWork

  const setRightToWork = (patch) =>
    setFormValues((prev) => ({
      ...prev,
      rightToWork: { ...prev.rightToWork, ...patch },
    }))

  return (
    <Stack gap={2}>
      <FormSection title="Citizenship">
        <Stack gap={1}>
          <Typography fontWeight={500}>I am…</Typography>
          {/* Stored values are the original sentence fragments — kept so
              existing applications still read correctly */}
          <ToggleButtonGroup
            exclusive
            color="primary"
            value={citizenship ?? null}
            onChange={(_, next) => next && setRightToWork({ citizenship: next })}
            sx={{ flexWrap: 'wrap', '& .MuiToggleButton-root': { px: 2.5 } }}
          >
            <ToggleButton value="a British Citizen">a British citizen</ToggleButton>
            <ToggleButton value="from somewhere else">
              from somewhere else
            </ToggleButton>
          </ToggleButtonGroup>
        </Stack>

        {citizenship === 'a British Citizen' && (
          <Stack gap={2.5} mt={1}>
            <YesNoQuestion
              label="Do you have a current or expired passport showing you are a British citizen?"
              value={hasUKPassport}
              onChange={(value) => setRightToWork({ hasUKPassport: value })}
            >
              <Alert severity="info" icon={false}>
                <AlertTitle>This does not include</AlertTitle>
                <Stack component="ul" m={0} pl={2.5}>
                  <li>British Nationals Overseas, for example from Hong Kong</li>
                  <li>British protected persons (from the former British Empire)</li>
                  <li>British subjects, for example from India before 1949</li>
                  <li>British Overseas Territories citizens</li>
                </Stack>
              </Alert>
            </YesNoQuestion>
            {hasUKPassport === false && (
              <YesNoQuestion
                label="Do you have a birth or adoption certificate from the UK, the Channel Islands or the Isle of Man?"
                value={hasBirthCertificate}
                onChange={(value) =>
                  setRightToWork({ hasBirthCertificate: value })
                }
              />
            )}
            {hasUKPassport === false && hasBirthCertificate === false && (
              <YesNoQuestion
                label="Do you have a certificate of registration or naturalisation as a British citizen?"
                value={certificateRegistration}
                onChange={(value) =>
                  setRightToWork({ certificateRegistration: value })
                }
              />
            )}
            {hasUKPassport === false &&
              hasBirthCertificate === false &&
              certificateRegistration === false && (
                <Alert severity="error">
                  <AlertTitle>
                    You do not have enough evidence of your entitlement to work
                    in the UK.
                  </AlertTitle>
                  Please speak with a member of the HR team.
                </Alert>
              )}
          </Stack>
        )}
      </FormSection>

      {citizenship && (
        <RightToWorkDocuments
          hasUKPassport={hasUKPassport}
          hasBirthCertificate={hasBirthCertificate}
          certificateRegistration={certificateRegistration}
          citizenship={citizenship}
          formValues={formValues}
          setFormValues={setFormValues}
        />
      )}
    </Stack>
  )
}

export default RightToWork
